import { useAuth0 } from '@auth0/auth0-react'

import { faShieldAlt, faUserCog } from '@fortawesome/pro-light-svg-icons'

import { TopBar } from '@domain-group/suit-theme'

import { generateUrls as generateAgencyUrls } from '@hooks/useAgency'
import useAgencySelector from '@hooks/useAgencySelector'
import useCurrentUser from '@hooks/useCurrentUser'
import { generateUrls as generateProviderUrls } from '@hooks/useProvider'
import { generateUrls as generateUserUrls } from '@hooks/useUser'

import ScopedConditionalContent from '@components/ScopedConditionalContent'

import handlePublicRouteChange from '@functions/handlePublicRouteChange'

interface LoggedInUserProps {
  boxProps?: object,
  darkMode?: boolean,
  isPublicRoute?: boolean,
}

const LoggedInUser = (props: LoggedInUserProps) => {
  const { boxProps, darkMode, isPublicRoute } = props

  const { logout, user } = useAuth0()
  const { 'https://www.realhubapp.com/role': roleName, name, picture } = user || {}

  const {
    agency, callbacks: { signOut }, currentUser, permissions, provider,
  } = useCurrentUser()
  const { selectedAgencyId } = useAgencySelector()

  const prefixRoute = agency.id ? `agencies/${selectedAgencyId}/manage` : undefined

  const { editAgencyUrl } = generateAgencyUrls(agency, { prefixRoute })
  const { editProviderUrl } = generateProviderUrls(provider)
  const { editUserUrl } = generateUserUrls(currentUser, { prefixRoute })

  const agencyAdminPagesPermissions: boolean = permissions?.agency?.admin?.agency_admin_pages?.manage !== undefined
   && permissions?.agency?.admin?.agency_admin_pages?.manage !== null
    ? permissions?.agency?.admin?.agency_admin_pages?.manage
    : true

  const adminUrl = agency.id ? editAgencyUrl : editProviderUrl

  return (
    <TopBar.LoggedInUser
      boxProps={boxProps}
      callbacks={{
        logout: () => {
          signOut()
          logout({ returnTo: window.location.origin })
        },
      }}
      darkMode={darkMode}
      imageUrl={picture}
      // @ts-expect-error TS2322
      title={name}
      subtitle={roleName}
    >
      <ScopedConditionalContent permittedRoleTitles={['Office Administrator', 'Office Director', 'Provider Director']}>
        {agencyAdminPagesPermissions && (
          <TopBar.DropdownLink
            href={!isPublicRoute ? adminUrl : undefined}
            icon={faUserCog}
            onClick={isPublicRoute ? () => handlePublicRouteChange(adminUrl) : undefined}
            text="Admin Settings"
          />
        )}
      </ScopedConditionalContent>

      <TopBar.DropdownLink
        href={!isPublicRoute ? editUserUrl : undefined}
        icon={faShieldAlt}
        onClick={isPublicRoute ? () => handlePublicRouteChange(editUserUrl) : undefined}
        text="Account Settings"
      />
    </TopBar.LoggedInUser>
  )
}

export default LoggedInUser
